import * as React from "react"
import {Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@mui/material";
import {formatProductsUnits} from "@ui-seeker/utils";

import {PricingImageSkuCell, PricingPriceCell, PricingRetailerCell, PricingSkuCell} from "./columns";
import { usePricingDiscountRoleConfig } from "Pages/Pricing/PriceDiscount/@hooks";


export default function PricingCandlestickTableModal({ data }) {

	const { isRetailerUser, isStandardUser } = usePricingDiscountRoleConfig()

	return <TableContainer component={Paper}>
		<Table sx={{ minWidth: 650 }}>
			<TableHead>
				<TableRow sx={{ th: { backgroundColor: "background.paper", fontWeight: 'normal' } }}>
					<TableCell />
					<TableCell>Product Name</TableCell>
					<TableCell>Retailer</TableCell>
					<TableCell align="center">{isStandardUser ? 'RRSP' : 'My Price'}</TableCell>
					<TableCell align="center">Retailer Price</TableCell>
					<TableCell align="center">Num Days Available</TableCell>
				</TableRow>
			</TableHead>
			<TableBody>
				{ data.map((row, idx) => <TableRow key={idx}>
					<PricingImageSkuCell skuID={row.skuID} />
					<PricingSkuCell sku={row.sku} brand={row.brand} category={row.category} ean={row.ean} />
					<PricingRetailerCell
						country={row.country}
						retailer={row.retailer}
						siteID={row.siteID}
						productID={row.productID}
						skuID={row.skuID}
					/>
					<PricingPriceCell price={row.myPrice} currency={row.currency} />
					<PricingPriceCell price={row.price} currency={row.currency} diff={row.diff} />
					<TableCell align="center">{formatProductsUnits(row.dispo)}</TableCell>
				</TableRow>) }
			</TableBody>
		</Table>
	</TableContainer>
}